"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var Input_1 = __importDefault(require("@material-ui/core/Input"));
var utils_1 = __importDefault(require("@nexys/utils"));
var MyInput = function (props) {
    var id = props.id, name = props.name, data = props.data, placeholder = props.placeholder, onChange = props.onChange, _a = props.disabled, disabled = _a === void 0 ? false : _a;
    var strName = name.toString();
    var initialValue = data && utils_1["default"].ds.get(strName, data);
    var _b = react_1["default"].useState(initialValue || ''), value = _b[0], setValue = _b[1];
    react_1.useEffect(function () {
        var initialValue = data && utils_1["default"].ds.get(strName, data);
        setValue(typeof initialValue === 'number' ? initialValue : '');
    }, [strName, data]);
    var handleChange = function (event) {
        var value = event.target.value;
        var valueNumber = Number(value);
        if (value === '') {
            setValue('');
        }
        else {
            if (!isNaN(valueNumber)) {
                onChange({ name: strName, value: valueNumber });
                setValue(valueNumber);
            }
        }
    };
    return (react_1["default"].createElement(StyledInput, { type: 'number', id: id ? id : strName, name: strName, value: value, onChange: handleChange, placeholder: placeholder, disabled: disabled, inputProps: {
            style: { textAlign: 'right' }
        }, fullWidth: true }));
};
var StyledInput = styled_components_1["default"](Input_1["default"])(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  input,\n  textarea {\n    padding-left: 0px;\n  }\n\n  text-align: 'right';\n"], ["\n  input,\n  textarea {\n    padding-left: 0px;\n  }\n\n  text-align: 'right';\n"])));
exports["default"] = MyInput;
var templateObject_1;
